import React from 'react'
import { Field, Form, withFormik } from 'formik'
import withStore from '../../../../../Components/Unstated/withStore'
import LeaveReviewStore from '../Store/LeaveReviewStore'
import * as Yup from 'yup'
import { string } from '../../../../UserAuth/Helpers/Form Validations/Validation Error Messages'
import { number } from '../../../../../Helpers/Form Validations/Validation Error Messages'
import Input from '../../../../../Components/Input/Input'
import Button from '../../../../../Components/Buttons/Button'
import { withRouter } from 'react-router-dom'

const LeaveReviewForm = () => {
  return (
    <div className='leaveReviewForm'>
      <h1>Leave a review</h1>
      <Form>
        <Field
          render={(props) => (
            <Input {...props} type='rating' placeholder={'Teacher Rating'} />
          )}
          name={'teacherRating'}
        />
        <Field
          render={(props) => (
            <Input {...props} type='textarea' placeholder={'Teacher Review'} />
          )}
          name={'teacherReview'}
        />
        <Field
          render={(props) => (
            <Input {...props} type='rating' placeholder={'Course Rating'} />
          )}
          name={'courseRating'}
        />
        <Field
          render={(props) => (
            <Input {...props} type='textarea' placeholder={'Course Review'} />
          )}
          name={'courseReview'}
        />
        <Button
          onClick={() => {}}
          name={'Submit'}
          type={'primary'}
          buttonType={'submit'}
        />
      </Form>
    </div>
  )
}

export default withRouter(
  withStore([LeaveReviewStore])(
    withFormik({
      mapPropsToValues: () => {
        return {
          teacherRating: '',
          teacherReview: '',
          courseRating: '',
          courseReview: '',
        }
      },
      validationSchema: () =>
        Yup.object().shape({
          teacherRating: Yup.number(number),
          teacherReview: Yup.string(string),
          courseRating: Yup.number(number),
          courseReview: Yup.string(string),
        }),
      handleSubmit: async (
        values,
        {
          props: {
            leaveReviewStore: { submitReview },
          },
          resetForm,
        },
      ) => {
        const success = await submitReview(values)
        if (success) {
          resetForm()
        }
      },
    })(LeaveReviewForm),
  ),
)
